// OPS Occult Library comparative visual archive v9 — Baphomet source pack.
(()=>{
  const TITLE='baphomet';
  const SOURCES=[
    {
      date:'1856',
      period:'Mid-19th century',
      creator:'Éliphas Lévi (Alphonse Louis Constant, 1810–1875)',
      work:'Baphomet / Sabbatic Goat, from Dogme et Rituel de la Haute Magie, vol. 2',
      page:'Volume 2; Commons source record does not state a printed page number',
      institution:'Wikimedia Commons digital reproduction; original published in Paris',
      collection:'Éliphas Lévi, Dogme et Rituel de la Haute Magie, vol. 2, 1856',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Baphomet_by_%C3%89liphas_L%C3%A9vi.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Baphomet_by_%C3%89liphas_L%C3%A9vi.jpg',
      rights:'Public domain; Commons Public Domain Mark / faithful reproduction of a public-domain work',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Éliphas Lévi, Baphomet, Dogme et Rituel de la Haute Magie, vol. 2, 1856. Public-domain reproduction via Wikimedia Commons.',
      medium:'Occult book illustration',
      process:'Printed line illustration; exact original print process is not stated by the Commons source record',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visual:'A highly symmetrical seated hybrid figure combines goat head, wings, torch, crescents, raised and lowered hands, the words SOLVE and COAGULA, and a central caduceus into one emblematic body.',
      note:'This is the image that stabilised the modern visual vocabulary of Baphomet. It is substantially later than the medieval Templar accusations associated with the name, so the archive treats it as a nineteenth-century construction rather than a surviving medieval idol portrait.',
      verifiedOn:'2026-09-14'
    },
    {
      date:'1886',
      period:'Late 19th century',
      creator:'Pierre Méjanel (drawing); François Pannemaker (engraving)',
      work:'Baphomet carried in procession, engraving 52 from Les Mystères de la Franc-Maçonnerie',
      page:'Engraving 52; Paris edition, 1886',
      institution:'Wikimedia Commons reproduction of the 1886 Paris publication',
      collection:'Léo Taxil, Les Mystères de la Franc-Maçonnerie, Paris, 1886',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/L%C3%A9o_Taxil-Myst%C3%A8res_de_la_Franc-Ma%C3%A7onnerie-gravure_52.jpg?width=1400',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:L%C3%A9o_Taxil-Myst%C3%A8res_de_la_Franc-Ma%C3%A7onnerie-gravure_52.jpg',
      rights:'Public domain; Commons Public Domain Mark',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Pierre Méjanel (drawing) and François Pannemaker (engraving), engraving 52 in Léo Taxil, Les Mystères de la Franc-Maçonnerie, Paris, 1886. Public-domain reproduction via Wikimedia Commons.',
      medium:'Book engraving',
      process:'Engraving after a drawing; the Commons record names Méjanel as draughtsman and Pannemaker as engraver',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visual:'The solitary emblem becomes a staged ritual scene: a winged goat-headed idol is elevated above a crowded procession, with architectural framing and dense hatch work giving the invented ceremony documentary weight.',
      note:'Taxil’s anti-Masonic material was part of a deliberate hoax, not evidence of an actual Masonic Baphomet rite. It remains useful visual history because it shows how Lévi’s image was repurposed into sensational narrative imagery within a generation.',
      verifiedOn:'2026-09-14'
    },
    {
      date:'1894',
      period:'Late 19th century',
      creator:'Léo Taxil and Charles Hacks; individual illustrator not identified in the Commons record',
      work:'“Le Baphomet”, illustration from Le Diable au XIXe siècle',
      page:'p. 89 (digital scan page 93)',
      institution:'Google Books scan / Wikimedia Commons; transcription context via French Wikisource',
      collection:'Léo Taxil and Charles Hacks, Le Diable au XIXe siècle, Delhomme et Briguet, 1894',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Taxil%2C_Hacks%2C_Le_Diable_au_XIXe_si%C3%A8cle%2C_p89.jpg?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Taxil,_Hacks,_Le_Diable_au_XIXe_si%C3%A8cle,_p89.jpg',
      rights:'Public domain; Commons Public Domain Mark',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Léo Taxil and Charles Hacks, “Le Baphomet”, Le Diable au XIXe siècle, 1894, p. 89. Public-domain scan via Google Books and Wikimedia Commons.',
      medium:'Printed book illustration',
      process:'Printed line illustration; exact print process is not stated by the source record',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visual:'A goat-headed idol is organised around a forehead pentagram, globe, emblematic signs and multiple serpents, expanding Baphomet from Lévi’s balanced single figure into a denser pseudo-archaeological display.',
      note:'The accompanying 1894 text presents the image as an alleged exact idol from a supposed Masonic temple in Calcutta. That claim belongs to Taxil and Hacks’s fabricated occult narrative; the archive records the plate as evidence of Baphomet’s visual reinvention, not of an actual ritual object.',
      verifiedOn:'2026-09-14'
    },
    {
      date:'1897',
      period:'Fin-de-siècle French occultism',
      creator:'Stanislas de Guaita (1861–1897)',
      work:'Inverted pentagram with goat head, from La Clef de la Magie Noire',
      page:'p. 417',
      institution:'Internet Archive source scan / Wikimedia Commons reproduction',
      collection:'Stanislas de Guaita, La Clef de la Magie Noire, 1897',
      imageUrl:'https://commons.wikimedia.org/wiki/Special:Redirect/file/Pentagram_with_one_point_down_(de_Guaita).jpg?width=1200',
      sourceUrl:'https://commons.wikimedia.org/wiki/File:Pentagram_with_one_point_down_(de_Guaita).jpg',
      rights:'Public domain; Commons Public Domain Mark',
      rightsUrl:'https://creativecommons.org/publicdomain/mark/1.0/',
      attribution:'Stanislas de Guaita, inverted pentagram with goat head, La Clef de la Magie Noire, 1897, p. 417. Public-domain reproduction via Wikimedia Commons.',
      medium:'Occult book diagram',
      process:'Printed line diagram',
      material:'Printing ink on paper',
      colour:'Monochrome',
      visual:'A frontal goat head is locked into an inverted pentagram and concentric circles, with Hebrew letters at the vertices. The composition compresses animal physiognomy, geometry and lettering into a compact seal-like device.',
      note:'This is not Lévi’s full Baphomet figure. It is included as a later visual branch because the design became a direct source for the twentieth-century “Sigil of Baphomet”; the distinction between the 1897 diagram and that later name is preserved in the record.',
      verifiedOn:'2026-09-14'
    }
  ];

  const key=(value)=>String(value||'').trim().toLowerCase();
  const nudgeRenderer=()=>{
    const target=document.querySelector('[data-library-reader]');
    if(!target) return;
    const marker=document.createComment('ops-visual-archive-v9-ready');
    target.appendChild(marker);
    marker.remove();
  };
  const install=()=>{
    const pack=window.OPS_OCCULT_EDITORIAL;
    if(!pack||!Array.isArray(pack.entries)) return false;
    const entry=pack.entries.find((item)=>key(item&&item.title)===TITLE);
    if(!entry) return false;
    entry.visualSources=SOURCES.map((source)=>({...source}));
    nudgeRenderer();
    return true;
  };
  if(!install()) document.addEventListener('DOMContentLoaded',install,{once:true});
})();
